import React from 'react';
import { useUserContext } from '@fff-web/fff-utilities';
import { trackEvent, identify, track } from '@fff-web/fff-analytics';
import capitalize from 'lodash/capitalize';
import { reactivateCancelledSubscription } from '../../../services/subscription';
import {
  syncDelay,
  getPlanChangeCompletedEventStatusFromResponse,
} from '../../../helpers';
import styles from './reactivate-button.module.scss';
import { redirectToBaseSite } from '../../../utils/redirectMethods';

const REACTIVATION_COMPLETED_EVENT = 'Reactivation Completed';
const REACTIVATION_COMPLETED_EVENT_TYPE = 'Canceled Member';
const REACTIVATION_EXPERIENCE = 'cancel flow';

const ReactivateButton = ({ isLoading, setIsLoading, setShowRetry, text='REACTIVATE NOW' }) => {
  const { invalidateUserCache, userInfo } = useUserContext();

  const handleOnClick = () => {
    setIsLoading(true);
    trackEvent({
      ctaName: 'Cancelled Reactivates',
      properties: { coupon_code: '' },
    });

    const sendSegmentEventAfterResponse = (status, callback) => {
      trackEvent({
        ctaName: 'Cancelled Reactivates Result',
        properties: { coupon_code: '', status },
      })
        .then(callback)
        .catch((e) => {
          // eslint-disable-next-line no-console
          console.warn(e);
          callback();
        });
    };

    reactivateCancelledSubscription()
      .then((response) => {
        track({
          trackName: REACTIVATION_COMPLETED_EVENT,
          properties: {
            cta_name: 'Reactivate Now',
            type: REACTIVATION_COMPLETED_EVENT_TYPE,
            experience: REACTIVATION_EXPERIENCE,
            reactivation_type: `Canceled ${capitalize(
              userInfo.user.subscriptionType.toLowerCase()
            )}`,
            status: getPlanChangeCompletedEventStatusFromResponse(response),
          },
        });
        if (response.ok) {
          sendSegmentEventAfterResponse('success', () => {
            invalidateUserCache();
            identify();
            syncDelay(5000);
            redirectToBaseSite();
          });
        } else {
          sendSegmentEventAfterResponse('failure', () => {
            // eslint-disable-next-line no-console
            console.error('An error had happened', response);
          });
          setIsLoading(false);
          setShowRetry(true);
        }
      })
      .catch((error) => {
        sendSegmentEventAfterResponse('failure', () => {
          // eslint-disable-next-line no-console
          console.error(error);
        });
        setIsLoading(false);
      });
  };

  return (
    <button
      type="button"
      className={styles['confirm-reactivate']}
      onClick={handleOnClick}
      disabled={isLoading}
    >
      {text}
    </button>
  );
};

export default ReactivateButton;
